/**
 * How the organisation console names the assistant that acts for the
 * organisation. Organisations with a Team Assistant have one, called Reve;
 * everywhere else the work is done by the members' own assistants, which the
 * copy must say instead of naming an assistant the admin has never met.
 */
export interface AssistantCopy {
  /** Whether the organisation has a Team Assistant (the tab is shown). */
  teamAssistant: boolean;
  /** Collective subject mid-sentence: "Reve" / "your team’s assistants". */
  who: string;
  /** `who` at the start of a sentence. */
  Who: string;
  /** Singular, distributive: "Reve" / "each member’s assistant". */
  each: string;
  /** `each` at the start of a sentence. */
  Each: string;
  /** In a sentence about one member: "Reve" / "their assistant". */
  theirs: string;
  /** `theirs` at the start of a sentence. */
  Theirs: string;
  /** Present-tense verb agreeing with `who`: agree('uses', 'use'). */
  agree: (singular: string, plural: string) => string;
}

const TEAM_ASSISTANT_NAME = 'Reve';

export function assistantCopy(teamAssistantsAvailable: boolean): AssistantCopy {
  if (teamAssistantsAvailable) {
    return {
      teamAssistant: true,
      who: TEAM_ASSISTANT_NAME,
      Who: TEAM_ASSISTANT_NAME,
      each: TEAM_ASSISTANT_NAME,
      Each: TEAM_ASSISTANT_NAME,
      theirs: TEAM_ASSISTANT_NAME,
      Theirs: TEAM_ASSISTANT_NAME,
      agree: (singular) => singular,
    };
  }
  return {
    teamAssistant: false,
    who: 'your team’s secretaries',
    Who: 'Your team’s secretaries',
    each: 'each member’s secretary',
    Each: 'Each member’s secretary',
    theirs: 'their secretary',
    Theirs: 'Their secretary',
    agree: (_singular, plural) => plural,
  };
}
